'use client';

import { memo } from 'react';
import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';
import { useWindowSizeStore } from 'src/stores/useWindowSizeStore';
import GridSectionWrapper from 'src/components/GridSections/GridSectionWrapper/GridSectionWrapper';
import Orderbook from './Orderbook/Orderbook';
import RecentMarketTrades from './RecentMarketTrades';
import Tabs from 'src/components/primitives/Tabs/Tabs';
import { TabOption } from 'src/components/primitives/Tabs/types';
import { useWindowSizeIsLessThan } from 'src/hooks/useWindowSize';

type OrderbookAndRecentTradesTab = 'orderbook' | 'recentTrades';

const TABS: TabOption<OrderbookAndRecentTradesTab>[] = [
	{
		value: 'orderbook',
		label: 'Orderbook',
	},
	{
		value: 'recentTrades',
		label: `Recent Trades`,
	},
];

const OrderbookAndRecentTrades = memo(function PublicTrades() {
	const isVertical = useWindowSizeStore(
		(s) => s.realtimeHeight > s.realtimeWidth
	);
	const isSmallScreen = useWindowSizeIsLessThan('sm');
	const isMediumScreen = useWindowSizeIsLessThan('md');

	const isSplit = (isVertical || isMediumScreen) && !isSmallScreen;

	const [currentTab, setCurrentTab] =
		useSyncLocalStorage<OrderbookAndRecentTradesTab>(
			'orderbookDisplayPreference',
			'orderbook'
		);

	return (
		<div className="h-full w-full">
			{isSplit ? (
				<div className="flex h-full w-full grow flex-row gap-xs">
					<GridSectionWrapper
						noPad
						className="relative flex flex-1 flex-col rounded-md border-none"
					>
						<Orderbook />
					</GridSectionWrapper>
					<GridSectionWrapper
						noPad
						className="relative flex flex-1 flex-col rounded-md border-none"
					>
						<RecentMarketTrades />
					</GridSectionWrapper>
				</div>
			) : (
				<GridSectionWrapper
					noPad
					className="relative h-full overflow-hidden rounded-md border-none bg-container-bg"
				>
					<div className="flex h-full grow flex-col">
						<Tabs
							className="gap-x-0"
							size="md"
							options={TABS}
							activeTab={currentTab}
							onTabChange={setCurrentTab}
							indicatorTrack
						/>
						{currentTab === 'recentTrades' ? (
							<RecentMarketTrades />
						) : (
							<Orderbook />
						)}
					</div>
				</GridSectionWrapper>
			)}
		</div>
	);
});

export default OrderbookAndRecentTrades;
